export const BLACKLAB_BASE = 'https://morphadorner.northwestern.edu/blacklab/earlyprint';
export const EXIST_BASE = '/exist/apps/shc'